import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { ButtonLoaddingSpinner } from '../components/Loading';
import { Content } from '../components/Content';
import Alert from '../components/Alert';

class ChangePasswordPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            password: '',
            passwordConfirm: '',
            passwordConfirmValid: true,
            passwordConfirmMessage: '',
            uid: null,
            uri: null,
            nextUri: null,
            token: null,
            showError: false,
            errors: [],
            loading: false,
            pwdChanged: false,
            formErrors: [],
            formValid: false,
            submitDisabled: true,
            redirect: false
        }
    }

    resetErrors = () => {
        this.setState({ showError: false, errors: [] });
    };


    componentDidMount() {
        const fromRedirect = this.props.history.action !== 'POP';

        if (!fromRedirect) {
            return this.props.history.push({
                pathname: '/'
            })
        }

        let { uid, uri, token } = this.props.location.state;
        this.setState({ uid: uid, uri: uri, token: token });
    }

    handleUserInput(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value })        
    }

    handleConfirmPassword(e) {
        const value = e.target.value;
        this.setState({ passwordConfirm: value });
        
        if (this.state.password === value) {
            e.target.className = 'form-control';
            this.setState({ submitDisabled: false});
        }
        else{
            e.target.className = 'form-control is-invalid';
            this.setState({ submitDisabled: true});
        }
    }

    validateForm() {
        const { password, passwordConfirm } = this.state;
        if (password !== passwordConfirm) {
            this.setState({ formValid: false, errors: [...this.state.errors, 'As senhas digitadas devem ser iguais'] });
        }
        this.setState({ formValid: true, errors: [] });
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        this.resetErrors();

        let data = new FormData(event.target);
        data.append('user-uid', this.state.uid);

        this.setState({ loading: true });

        const response = await fetch(this.state.uri, {
            headers: new Headers({
                'Api-Token': 'Bearer ' + this.state.token
            }),
            method: 'POST',
            body: data
        });

        const jsonResponse = await response.json();

        this.setState({ loading: false });

        if (jsonResponse.error) {
            this.setState({ showError: true, errors: [...this.state.errors, jsonResponse.error.message] });
            return;
        }

        this.setState({ pwdChanged: true, nextUri: jsonResponse.links.href })
    };

    renderForm = (loading, errors) => (
        <React.Fragment>
            <div className="box-header with-border">
                <Alert message="Identificamos que a sua senha não atende aos requisitos de segurança e será necessario alterá-la." />
            </div>
            <form className="form-signin" method="POST" encType="application/json" onSubmit={this.handleSubmit}>
                <span className="text-muted text-justify font-italic">
                    <span>Por  questões de segurança, a senha deve seguir os critérios abaixo:</span>
                    <span>
                        <ul>
                            <li>Mínimo 8 caracteres </li>
                            <li>Pelo menos uma letra maiúscula</li>
                            <li>Pelo menos um número</li>
                            <li>Pelo menos um caracter especial (Ex.: !#@$&%*)</li>
                        </ul>
                    </span>
                </span>
                {this.state.showError ? <Alert message={errors} /> : <div />}
                <div className="form-group">
                    <label htmlFor="password"></label>
                    <input
                        id="password"
                        type="password"
                        name="password"
                        className="form-control"
                        placeholder="Informe uma nova senha"
                        required
                        autoFocus=""
                        value={this.state.password}
                        onChange={(event) => this.handleUserInput(event)}
                    />
                </div>
                <div className="form-group">
                    <label htmlFor="password2"></label>
                    <input
                        id="password2"
                        type="password"
                        name="passwordConfirm"
                        className="form-control"
                        placeholder="Digite novamente a nova senha"
                        required
                        value={this.state.passwordConfirm}
                        onChange={(e) => this.handleConfirmPassword(e)}
                    />
                    <div className="invalid-feedback">
                        A senha de confirmação não é a mesma senha digitada! Por favor reveja as senhas digitadas.
                    </div>
                </div>
                {this.state.submitDisabled && <button id="btn-change-password" className="btn btn-lg btn-primary btn-block" type="submit" disabled>Enviar</button>}
                {loading ? <ButtonLoaddingSpinner /> : !this.state.submitDisabled && <button id="btn-change-password" className="btn btn-lg btn-primary btn-block" type="submit">Enviar</button>}

            </form>
        </React.Fragment>
    );

    renderRedirect = () => {
        if (this.state.redirect) {
            return <Redirect to={{
                pathname: `${process.env.PUBLIC_URL}/account-choices`,
                state: {
                    notifyMessage: 'Sua senha foi alterada com sucesso. Agora é necessario escolher a sua conta institucional.',
                    uid: this.state.uid,
                    uri: this.state.nextUri,
                    token: this.state.token
                }
            }}
            />
        }
    }

    renderPasswordChangeSuccess = () => {
        return (
            <React.Fragment>
                <div className="alert alert-success">
                    A sua senha foi alterada com sucesso, agora você pode escolher a sua conta institucional cliando abaixo.
                </div>

                <hr className="my-4" />
                <button className="btn btn-primary btn-lg btn-block" onClick={() => this.setState({ redirect: true })}>Clique aqui para a criação da Conta Institucional</button>
                <small className="text text-muted">A sua conta institucional lhe dará acesso aos serviços da UFVJM.</small>
            </React.Fragment>
        )
    }

    render() {
        const { loading, pwdChanged, redirect, errors } = this.state;

        return (
            <Content stepName="Alteração de senha" cancelButton={true}>
                {!pwdChanged && this.renderForm(loading, errors)}
                {pwdChanged && this.renderPasswordChangeSuccess()}
                {redirect && this.renderRedirect()}
            </Content >
        );
    }
}

export default ChangePasswordPage;
